export default __webpack_public_path__ + "static/careem-0fcdb56757baab22b474a857ccee7d2f.svg";